import React from 'react';
import { Helmet } from 'react-helmet-async';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import DescriptionIcon from '@material-ui/icons/Description';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import { PageHero, Section, SectionHeading, LinkCard } from './PageLayout';

/** Fallback page for unmatched routes. */
export default function NotFound() {
    return (
        <>
            <Helmet>
                <title>Page not found | Ministry of Finance, Timor-Leste</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <PageHero
                eyebrow="Error 404"
                title="We could not find that page"
                description="The page you requested may have been moved, renamed or removed. Use the options below to continue, or search the portal for what you need."
                breadcrumbs={[{ label: 'Page not found' }]}
                actions={
                    <>
                        <Button variant="contained" color="primary" href="/">
                            Return to homepage
                        </Button>
                        <Button
                            variant="outlined"
                            href="/searchpage"
                            style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.6)' }}
                        >
                            Search the portal
                        </Button>
                    </>
                }
            />

            <Section>
                <SectionHeading
                    overline="Popular destinations"
                    title="Where would you like to go?"
                    description="These are the sections of the portal most often requested by the public."
                />
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <LinkCard
                            icon={<AnnouncementIcon />}
                            title="News and announcements"
                            description="Official press releases, statements and events from the Ministry."
                            to="/latestnews"
                            cta="View news"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <LinkCard
                            icon={<DescriptionIcon />}
                            title="Publications and reports"
                            description="Budget books, execution reports, laws and statistical releases."
                            to="/publications"
                            cta="Browse publications"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <LinkCard
                            icon={<SearchIcon />}
                            title="Open tenders"
                            description="Current procurement opportunities and tender documentation."
                            to="/tenders"
                            cta="View tenders"
                        />
                    </Grid>
                </Grid>
            </Section>
        </>
    );
}
